import { SetDepartmentInSection } from "../../../../types/permissions/departmentSectionInterface";
import api from "../../../../lib/api";


export const getDepartmentSectionListApi = async () => {
  return await api.get(`department-section`);
};

export const setDepartmentInSectionsApi = async (data: SetDepartmentInSection[]) => {
  return await api.post(`department-section/`, data);
};